import ForgotPassword from '../../components/RegoForm/auth/ForgotPassword'
import ResetPassword from '../../components/RegoForm/auth/ResetPassword'
import Signup from '../../components/RegoForm/auth/Signup'
import SignupGuest from '../../components/RegoForm/auth/SignupGuest'
import SignupSuccess from '../../components/RegoForm/auth/SignupSuccess'
import VerifyEmail from '../../components/RegoForm/auth/VerifyEmail'
import InitialForm from '../../components/RegoForm/pages/InitialForm'
import Form from '../../components/RegoForm/private'
import { secondRoutes } from './routes'

const registrationRoutesMap = {
  login: InitialForm,
  form: Form,
  signup: Signup,
  signupGuest: SignupGuest,
  forgotPassword: ForgotPassword,
  resetPassword: ResetPassword,
  verifyEmail: VerifyEmail,
  signupSuccess: SignupSuccess,
}

export default secondRoutes.reduce((acc, route) => {
  if (Object.hasOwn(registrationRoutesMap, route.id)) {
    // eslint-disable-next-line no-param-reassign
    route.component = registrationRoutesMap[route.id]
  }
  acc.push(route)
  return acc
}, [])
